/**
 * @author Simeon Artamonov <simeon@cross-works.co.uk>
 * @company Cross Works Ltd
 */
import { ref } from 'vue'

interface OverlayImage {
  url: string
  alt?: string
  caption?: string
}

const isOverlayOpen = ref(false)
const overlayImage = ref<OverlayImage | null>(null)
let savedScrollPosition = 0

export function useImageOverlay() {
  const openOverlay = (image: OverlayImage) => {
    // Save current scroll position before opening overlay
    savedScrollPosition = window.pageYOffset || document.documentElement.scrollTop
    
    overlayImage.value = image
    isOverlayOpen.value = true
    
    // Prevent body scroll when overlay is open
    document.body.classList.add('overlay-open')
    document.body.style.top = `-${savedScrollPosition}px`
  }

  const closeOverlay = () => {
    isOverlayOpen.value = false
    overlayImage.value = null
    
    // Re-enable body scroll and restore scroll position
    document.body.classList.remove('overlay-open')
    document.body.style.top = ''
    
    // Restore the scroll position
    window.scrollTo(0, savedScrollPosition)
  }

  return {
    isOverlayOpen,
    overlayImage,
    openOverlay,
    closeOverlay
  }
} 